import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
/**
 * SectionDivider — zachte golf/blob overgang tussen secties met
 * verschillende achtergrondkleuren. Voorkomt de "platte stapel rechthoeken"
 * look en geeft de pagina een vloeiend, organisch gevoel.
 *
 * Props:
 * - from: achtergrondkleur waar je vandaan komt (de bovenste sectie)
 * - to:   achtergrondkleur waar je naartoe gaat (de onderste sectie)
 * - variant: 'wave' (golf) | 'tilt' (diagonaal) | 'blob' (organisch)
 * - flip: spiegel verticaal voor variatie
 */
type Variant = 'wave' | 'tilt' | 'blob';
interface Props {
  from?: string;
  to?: string;
  variant?: Variant;
  flip?: boolean;
  height?: number;
  parallax?: boolean;
}
export function SectionDivider({
  from = '#FFF9F2',
  to = '#FFFFFF',
  variant = 'wave',
  flip = false,
  height = 80,
  parallax = true
}: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const x = useTransform(scrollYProgress, [0, 1], ['-4%', '4%']);
  return <div ref={ref} aria-hidden="true" className="relative w-full pointer-events-none select-none" style={{
    height,
    background: from,
    marginTop: -1
  }} data-id="element-696">
      <motion.svg viewBox="0 0 1440 120" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" style={{
      x: parallax ? x : undefined,
      transform: flip ? 'scaleY(-1)' : undefined
    }} data-id="element-697">
        {variant === 'wave' && <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill={to} data-id="element-698" />}
        {variant === 'tilt' && <path d="M0,80 L1440,20 L1440,120 L0,120 Z" fill={to} data-id="element-699" />}
        {variant === 'blob' && <path d="M0,60 C180,20 360,90 540,60 C720,30 900,100 1080,70 C1260,40 1380,80 1440,60 L1440,120 L0,120 Z" fill={to} data-id="element-700" />}
      </motion.svg>
    </div>;
}